// 2020-06-27export { MyMessageDialogComponent } from './my-message-dialog.component';